import React from 'react'
import { styled } from '@mui/material/styles'
import { classToFComponent, FCClassContext, LifesHubColors } from 'src/utils/views'
import { TcmCard } from 'src/utils/views/modules/the-consumer-market'

import TcmProgress from '../../the-consumer-market/views/helpers/tcm_progress'
import { ComparativoScope } from '../ad_scopes'

const Rolagem = styled('div')({
    position: 'relative',
    flexGrow: 1,
    minHeight: 0,
    overflow: 'auto',
    border: '1px solid var(--border)',
    borderRadius: 7
})

const ROTULO_PX = 300
const COLUNA_MIN_PX = 150

const Tabela = styled('table')({
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'separate',
    borderSpacing: 0,
    fontSize: 12,
    color: 'var(--ink)',
    '& th, & td': {
        padding: '5px 10px',
        borderBottom: `1px solid ${LifesHubColors.gridLine}`,
        whiteSpace: 'nowrap',
        lineHeight: 1.3
    },
    '& thead th': {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: 'var(--surface-2)',
        borderBottom: '1px solid var(--border)',
        fontSize: 11.5,
        fontWeight: 700,
        textAlign: 'center',
        whiteSpace: 'normal',
        verticalAlign: 'bottom'
    },
    '& thead th:first-of-type': { left: 0, zIndex: 3, textAlign: 'left', width: ROTULO_PX },
    '& tbody th': {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        textAlign: 'left',
        fontWeight: 600,
        backgroundColor: 'var(--green-050)',
        borderRight: '1px solid var(--border)'
    },
    '& tbody td': {
        textAlign: 'right',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    '& tbody tr:hover td, & tbody tr:hover th': { backgroundColor: 'var(--green-100)' },
    '& tbody tr:last-of-type th, & tbody tr:last-of-type td': { borderBottom: 0 }
})

const Vazio = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    padding: 24,
    textAlign: 'center',
    fontSize: 13,
    color: 'var(--muted)'
})

type ComparativoViewProps = {
    className?: string
    scope: ComparativoScope
}

class ComparativoViewClass implements FCClassContext<ComparativoViewProps> {
    render({ className, scope }: ComparativoViewProps) {
        return (
            <TcmCard className={className} caption={scope.caption}>
                {!scope.loaded && <TcmProgress />}
                {scope.loaded && scope.vazio && <Vazio>{scope.vazio}</Vazio>}
                {scope.loaded && !scope.vazio && (
                    <Rolagem>
                        <Tabela style={{ minWidth: ROTULO_PX + scope.operadoras.length * COLUNA_MIN_PX }}>
                            <thead>
                                <tr>
                                    <th />
                                    {scope.operadoras.map((op) => (
                                        <th key={op}>{op}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {scope.linhas.map((linha) => (
                                    <tr key={linha.id}>
                                        <th>{linha.rotulo}</th>
                                        {linha.valores.map((valor, i) => (
                                            <td key={i} title={linha.detalhes[i]}>
                                                {valor}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </Tabela>
                    </Rolagem>
                )}
            </TcmCard>
        )
    }
}

export const ComparativoView = classToFComponent(ComparativoViewClass, React)
